export enum TeamStatusEnum {
  Terminated = "0",
  Active = "1",
}
